/*
 * @Author: yanghailong
 * @Date: 2023-08-23 09:07:01
 * @Last Modified by: yanghailong
 * @Last Modified time: 2025-01-08 10:23:53
 */
import { AddObjectRecord } from "../history/record.js"
import { CircleElement } from "./element-circle.js"
import { RectElement } from "./element-rect.js"
import { TextElement } from "./element-text.js"
import { FoldLineElement } from "./element-fold-line.js"

export function createFromJSON(Ctor) {
  return function (topology, node, complete) {
    return new Promise((resolve) => {
      let elem = new Ctor(topology, node.attrs.x, node.attrs.y)
      // set  uuid
      elem.uuid = node.uuid
      // set other attrs
      elem.deviceIpAddress = node.deviceIpAddress
      elem.deviceUUID = node.deviceUUID

      elem.onLoad(() => {

        if (elem instanceof CircleElement || elem instanceof RectElement || elem instanceof TextElement || elem instanceof FoldLineElement) {
          // 设置基本元件的属性
          elem.keyShape.setAttrs(node.keyShapeAttrs)
          elem.updatePortPosition()
        }

        elem.label.setAttr('text', node.label)
        // set port uuid
        elem.ports.portDown.setAttr('uuid', node.ports.portDown)
        elem.ports.portUp.setAttr('uuid', node.ports.portUp)
        elem.setPropertyVisible(node.showProperties)
        // add element
        topology.storage.addElement(elem)
        topology.history.push(new AddObjectRecord(topology, elem))

        complete && complete()
        resolve(elem)
      })
    })
  }
}
